var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page 1 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38932 3.11108H6.22266V7.77775L9.9171 9.99442L10.5004 9.03775L7.38932 7.19442V3.11108ZM7 0C3.13367 0 0 3.13367 0 7C0 10.8663 3.13367 14 7 14C10.8663 14 14 10.8663 14 7C14 3.13367 10.8663 0 7 0ZM7.00011 12.4444C3.99322 12.4444 1.55566 10.0069 1.55566 6.99999C1.55566 3.9931 3.99322 1.55554 7.00011 1.55554C10.007 1.55554 12.4446 3.9931 12.4446 6.99999C12.4446 10.0069 10.007 12.4444 7.00011 12.4444Z",
    fill: "#6B778B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4d132898b38312539b28cb912becfe59.svg";
export { ForwardRef as ReactComponent };